module.exports = __webpack_public_path__ + "img/bonus_pc_km.d8d63ad7.png";